import * as type from "../types/single-contact-list";

const initialState = {
  details: {
    name: null,
    description: null,
  },
  records: [],
  deletionArray: [],
  fieldOverrides: [],
  fetchDetails: {
    status: null,
    loading: true,
    error: null,
  },
  fetchRecords: {
    status: null,
    loading: true,
    error: null,
  },
  addSingleRecord: {
    status: null,
    loading: false,
    error: null,
  },
  addSingleCsv: {
    status: null,
    loading: false,
    error: null,
  },
  viewSingleRecord: {
    status: null,
    loading: false,
    error: null,
  },
  updateSingleRecord: {
    status: null,
    loading: false,
    error: null,
  },
  deleteSingleRecord: {
    status: null,
    loading: false,
    error: null,
  },
  deleteArray: {
    status: null,
    loading: false,
    error: null,
  },
  activeDisplay: {},
  activeEdit: {},
  activeDeletion: {
    id: null,
  },
  showModals: {
    addCsvModal: false,
    addSingleModal: false,
    deleteSingleModal: false,
    editSingleModal: false,
  },
};

export const singleContactList = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_SINGLE_CONTACT_LIST_DETAILS:
      return {
        ...state,
        details: {},
        fetchDetails: {
          ...state.fetchDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_SINGLE_CONTACT_LIST_DETAILS:
      return {
        ...state,
        details: payload.details,
        fetchDetails: {
          ...state.fetchDetails,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SINGLE_CONTACT_LIST_DETAILS:
      return {
        ...state,
        details: {},
        fetchDetails: {
          ...state.fetchDetails,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SINGLE_CONTACT_LIST_DETAILS:
      return {
        ...state,
        details: {},
        fetchDetails: {
          ...state.fetchDetails,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_SINGLE_CONTACT_LIST_RECORDS:
      return {
        ...state,
        records: [],
        fetchRecords: {
          ...state.fetchRecords,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_SINGLE_CONTACT_LIST_RECORDS:
      return {
        ...state,
        records: payload.details,
        fetchRecords: {
          ...state.fetchRecords,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SINGLE_CONTACT_LIST_RECORDS:
      return {
        ...state,
        records: [],
        fetchRecords: {
          ...state.fetchRecords,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SINGLE_CONTACT_LIST_RECORDS:
      return {
        ...state,
        records: [],
        fetchRecords: {
          ...state.fetchRecords,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.CHANGE_SINGLE_CONTACT_LIST_MODAL:
      if (
        payload.modal.addCsvModal === true ||
        payload.modal.addCsvModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addCsvModal: payload.modal.addCsvModal,
          },
        };
      } else if (
        payload.modal.addSingleModal === true ||
        payload.modal.addSingleModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addSingleModal: payload.modal.addSingleModal,
          },
        };
      } else if (
        payload.modal.deleteSingleModal === true ||
        payload.modal.deleteSingleModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteSingleModal: payload.modal.deleteSingleModal,
          },
        };
      } else if (
        payload.modal.editSingleModal === true ||
        payload.modal.editSingleModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editSingleModal: payload.modal.editSingleModal,
          },
        };
      } else {
        return state;
      }
    case type.REQUEST_ADD_SINGLE_CONTACT_LIST_RECORD:
      return {
        ...state,
        addSingleRecord: {
          ...state.addSingleRecord,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_SINGLE_CONTACT_LIST_RECORD:
      return {
        ...state,
        addSingleRecord: {
          ...state.addSingleRecord,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_ADD_SINGLE_CONTACT_LIST_RECORD:
      return {
        ...state,
        addSingleRecord: {
          ...state.addSingleRecord,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_ADD_SINGLE_CONTACT_LIST_RECORD:
      return {
        ...state,
        addSingleRecord: {
          ...state.addSingleRecord,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY:
      return {
        ...state,
        activeDisplay: payload.details,
      };
    case type.RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY:
      return {
        ...state,
        activeDisplay: {},
      };
    case type.SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT:
      return {
        ...state,
        activeEdit: payload.details,
      };
    case type.RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT:
      return {
        ...state,
        activeEdit: null,
      };
    case type.REQUEST_VIEW_CONTACT_SELECTION:
      return {
        ...state,
        activeDisplay: {},
        viewSingleRecord: {
          ...state.viewSingleRecord,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_VIEW_CONTACT_SELECTION:
      return {
        ...state,
        activeDisplay: payload.details,
        viewSingleRecord: {
          ...state.viewSingleRecord,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_VIEW_CONTACT_SELECTION:
      return {
        ...state,
        activeDisplay: {},
        viewSingleRecord: {
          ...state.viewSingleRecord,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_VIEW_CONTACT_SELECTION:
      return {
        ...state,
        activeDisplay: {},
        viewSingleRecord: {
          ...state.viewSingleRecord,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_CONTACT_SELECTION:
      return {
        ...state,
        updateSingleRecord: {
          ...state.updateSingleRecord,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_UPDATE_CONTACT_SELECTION:
      return {
        ...state,
        activeDisplay: payload.details,
        updateSingleRecord: {
          ...state.updateSingleRecord,
          status: "success",
          loading: false,
          error: null,
        },
        records: state.records.map((record) =>
          record.id === payload.details.id ? payload.details : record
        ),
      };
    case type.REVOKE_UPDATE_CONTACT_SELECTION:
      return {
        ...state,
        updateSingleRecord: {
          ...state.updateSingleRecord,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_UPDATE_CONTACT_SELECTION:
      return {
        ...state,
        updateSingleRecord: {
          ...state.updateSingleRecord,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.APPEND_CONTACTS_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: [...state.deletionArray, payload.id],
      };
    case type.SUBTRACT_CONTACTS_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: state.deletionArray.filter(
          (existing) => existing !== payload.id
        ),
      };
    case type.REQUEST_DELETE_SINGLE_CONTACT_LIST_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_SINGLE_CONTACT_LIST_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_SINGLE_CONTACT_LIST_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: payload.details,
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_SINGLE_CONTACT_LIST_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_ACTIVE_CONTACT_DELETION:
      return {
        ...state,
        activeDeletion: {
          ...state.activeDeletion,
          id: payload.data.id,
        },
      };
    case type.RESET_ACTIVE_CONTACT_DELETION:
      return {
        ...state,
        activeDeletion: {
          id: null,
        },
      };
    case type.REQUEST_DELETE_SINGLE_CONTACT:
      return {
        ...state,
        deleteSingleRecord: {
          ...state.deleteSingleRecord,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_SINGLE_CONTACT:
      return {
        ...state,
        deleteSingleRecord: {
          ...state.deleteSingleRecord,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_SINGLE_CONTACT:
      return {
        ...state,
        deleteSingleRecord: {
          ...state.deleteSingleRecord,
          status: payload.details,
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_SINGLE_CONTACT:
      return {
        ...state,
        deleteSingleRecord: {
          ...state.deleteSingleRecord,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.APPEND_CSV_FIELD_OVERRIDES_ARRAY:
      if (
        !state.fieldOverrides.some((item) => item.key === payload.details.key)
      ) {
        return {
          ...state,
          fieldOverrides: [...state.fieldOverrides, payload.details],
        };
      } else {
        return {
          ...state,
          fieldOverrides: state.fieldOverrides.map((item) =>
            item.key === payload.details.key ? payload.details : item
          ),
        };
      }
    case type.SUBTRACT_CSV_FIELD_OVERRIDES_ARRAY:
      return {
        ...state,
        fieldOverrides: state.fieldOverrides.filter(
          (existing) => existing.key !== payload.details.key
        ),
      };
    case type.REQUEST_UPLOAD_SINGLE_CSV_FILE:
      return {
        ...state,
        addSingleCsv: {
          ...state.addSingleCsv,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPLOAD_SINGLE_CSV_FILE:
      return {
        ...state,
        addSingleCsv: {
          ...state.addSingleCsv,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPLOAD_SINGLE_CSV_FILE:
      return {
        ...state,
        addSingleCsv: {
          ...state.addSingleCsv,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPLOAD_SINGLE_CSV_FILE:
      return {
        ...state,
        addSingleCsv: {
          ...state.addSingleCsv,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
